/**
 * sportsbookTiers.js — sportsbook tier lists derived from sportsbooks.json.
 * Extracted from SgpFlowScreen.jsx so SgpFilterPanel and the screen share one source.
 */

import allSportsbooksJson from './sportsbooks.json';

export const MAJOR_SPORTSBOOKS = allSportsbooksJson.filter(b => b.category === 'major').map(b => b.name);
export const SECONDARY_SPORTSBOOKS = allSportsbooksJson.filter(b => b.category === 'secondary').map(b => b.name);
export const INTERNATIONAL_SPORTSBOOKS = allSportsbooksJson.filter(b => b.category === 'international').map(b => b.name);
export const DFS_SPORTSBOOKS = allSportsbooksJson.filter(b => b.category === 'dfs').map(b => b.name);
